/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui'


/* ++++++++++ --------------- EXPORT : COMMENTING CONFIGURATION ADMIN SECTION : STYLES --------------- ++++++++++ */
export default theme => ({
  placement: {
    '& .name-Dynamic': {
      zIndex: 11
    },
    '& .name-menuItems': {
      position: 'relative',
      zIndex: 10
    }, 
    '& .field': {
      width: '100%'
    },
    '& .type-checkbox': {
      alignItems: 'start' 
    },
    '& .singleselectdropdown': {
      width: '100%'
    },
    width: '50%',
    '& .radiospan': {
      width: pxToEm(20),
      height: pxToEm(20),
      '&::after': {
        top: pxToEm(5),
        left: pxToEm(5),
        width: pxToEm(6),
        height: pxToEm(6)
      }
    },
    '& .disabled-true': {
      pointerEvents: 'none',
      opacity: 0.5
    }
  }
});
